import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { Button, FileUpload, Modal, Spacing, Typography } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { CustomFileUpload } from 'modules/dashboard/styles/dashboard';

import { ImportModalContainer } from '../styles/import-modal';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as CSVIcon } from 'assets/icons/csv-file.svg';
import { ReactComponent as ExcelIcon } from 'assets/icons/excel-file.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';

import { COLOR, COLOR_CONFIG } from 'constants/color';

import { useImportLearnerController } from '../core/controller/import-learner';

export const ImportModal = () => {
  const {
    institutionValue,
    institutions,
    searchSelect,
    onChangeInstitution,
    onChangeSearchInstitution,
    handleChangeFile,
    handleDownloadTemplate,
    handleImportFile,
    isBiologicAdmin,
    disabled,
    file,
    handleRemoveFile,
  } = useImportLearnerController();

  return (
    <ImportModalContainer>
      <Modal
        modalKey={MODAL_KEY.IMPORT_LEARNER}
        footer={
          <div
            style={{
              padding: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={handleImportFile}
              disabled={disabled}
              style={{
                fontSize: 18,
                lineHeight: '26px',
              }}
            >
              Import
            </Button>
          </div>
        }
        header="Import clients"
      >
        {isBiologicAdmin && (
          <Spacing
            spacing="xxl"
            placement="bottom"
            type="margin"
            style={{
              width: '100%',
            }}
          >
            <InputTitle title="Select institution" />
            <CommonSelect
              value={institutions.find((item: any) => item.value === institutionValue)}
              options={institutions.filter((item: any) =>
                item.label.toLowerCase().includes(searchSelect.value.toLowerCase()),
              )}
              onChange={onChangeInstitution}
              onInputChange={onChangeSearchInstitution}
              noOptionsMessage={() => 'Not Found Institution'}
              placeholder="Import to this institution"
            />
          </Spacing>
        )}

        <Typography
          style={{
            fontSize: 18,
            lineHeight: '26px',
            color: COLOR.surfaceNeutralBold['neutral-11'],
          }}
        >
          Download our sample{' '}
          <span
            style={{
              color: COLOR.purpel['purpel-6'],
              textDecorationLine: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => handleDownloadTemplate('csv')}
          >
            CSV template
          </span>{' '}
          or{' '}
          <span
            style={{
              color: COLOR.purpel['purpel-6'],
              textDecorationLine: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => handleDownloadTemplate('xlsx')}
          >
            EXCEL template
          </span>{' '}
          to see the required format.
        </Typography>

        <div style={{ padding: '12px 0' }}>
          {file.name ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                border: '1px solid rgba(0, 0, 0, 0.25)',
                borderRadius: 12,
                padding: '27px 12px 27px 16px',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {file.name.includes('.csv') ? <CSVIcon /> : <ExcelIcon />}

                <div>
                  <Typography
                    style={{
                      fontSize: 18,
                      lineHeight: '26px',
                      color: COLOR.surfaceNeutralBold['neutral-11'],
                    }}
                  >
                    {file.name}
                  </Typography>
                  <Typography
                    style={{
                      fontSize: 14,
                      lineHeight: '20px',
                      color: COLOR_CONFIG['neutral-text'],
                    }}
                  >
                    {file.size} KB
                  </Typography>
                </div>
              </div>
              <CloseIcon style={{ cursor: 'pointer' }} onClick={handleRemoveFile} />
            </div>
          ) : (
            <CustomFileUpload>
              <FileUpload
                id={'file'}
                icon={<UploadIcon />}
                title="Click or drag and drop to upload"
                onChangeFiles={handleChangeFile}
                accept=".xlsx, .csv, .xls"
                style={{ height: 160 }}
              />
            </CustomFileUpload>
          )}
        </div>

        <Typography
          style={{ fontSize: 16, lineHeight: '22px', color: COLOR_CONFIG['neutral-text'] }}
        >
          Supported format: CSV and XLXS
        </Typography>
      </Modal>
    </ImportModalContainer>
  );
};
